import { createContext, useContext } from "react";
import type { FieldComposerConfig } from "@/features/form-fields";

interface FieldContextValue {
    fieldPath: string;
    fieldConfig: FieldComposerConfig;
    fieldHtmlId: string;
    exactnessFieldPath?: string;
}

const FieldContext = createContext<FieldContextValue | null>(null);

export const useFieldContext = () => {
    const context = useContext(FieldContext);
    if (!context) {
        throw new Error("useFieldContext must be used within a FieldProvider");
    }
    return context;
};

export const FieldProvider = FieldContext.Provider;
